import './center.css'
import './web_component'
import React from 'react'
import { CenterLayoutProps } from './types'

export const Center: React.FC<CenterLayoutProps> = ({ children, ...props }) => (
  <center-l {...props}>{children}</center-l>
)
